import request from '@/axios'

// (rad1)-02-提交评测
export function saveInvite(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_one/saveInvite',
    method: 'post',
    data
  })
}
// (rad1)-04-装修关注点列表
export function getFocusList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_one/getFocusList',
    method: 'post',
    data
  })
}
// (rad1)-05-装修风格类型列表
export function getStyleList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_one/getStyleList',
    method: 'post',
    data
  })
}
// (rad1)-06-邀请涵详情
export function getInviteInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_one/getInviteInfo',
    method: 'post',
    data
  })
}
// STEP01-0202-风格探索
export function getPreference(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/design_system/demand/getPreference',
    method: 'post',
    data
  })
}
// (rad1)-01-修改邀请函状态
export function saveInviteStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_one/saveInviteStatus',
    method: 'post',
    data
  })
}
// STEP01-0201-(风格偏好)列表
export function preferenceList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/design_system/demand/preferenceList',
    method: 'post',
    data
  })
}
// 04-获取选项字段选择下拉列表
export function getSelectFieldOption(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getSelectFieldOption',
    method: 'post',
    data
  })
}

// 交房状态
export function getHouseStatusList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getHouseStatusList',
    method: 'post',
    data
  })
}
// designer-01-设计服务空间列表
export function getSpaceList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getSpaceList',
    method: 'post',
    data
  })
}
// CM-04-获取成员
export function getMembers(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getMembers',
    method: 'post',
    data
  })
}
// (rad1)-03-初步需求评估结果
export function getEvaluating(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_one/getEvaluating',
    method: 'post',
    data
  })
}
// designer-04-获取成员兴趣爱好
export function getInterests(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getInterests',
    method: 'post',
    data
  })
}

// (rad1)-02-新提交评测（0723）
export function saveInviteV2(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_one/saveInviteV2',
    method: 'post',
    data
  })
}

// (rad1)-02-获取选项（0723）
export function getSelectOperation(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_one/getSelectOperation',
    method: 'post',
    data
  })
}
